/* eslint-disable @typescript-eslint/no-explicit-any */

export enum HttpServiceEvents {
	ERROR = 'response-error'
}

export default class ResponseError extends Error {
	public response: Partial<TRA.IResponse<any>>;

	constructor(response: Partial<TRA.IResponse<any>>, m?: string) {
		super(m);

		// https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
		Object.setPrototypeOf(this, ResponseError.prototype);

		this.response = response;
		this.name = ResponseError.name;
	}
}
